"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["dropdown.small[_ngcontent-%COMP%]     .dropdown-button{padding:0 20px 0 5px;height:24px;line-height:22px}dropdown.small[_ngcontent-%COMP%]     .dropdown-button:after{top:3px;right:3px}"];
exports.styles = styles;
